import * as React from 'react'
import { LucideIcon, LucideIconName } from 'utils/lucideIcon'
import { TooltipWrapper } from 'uiComponents/tooltip.new/tooltipWrapper'
import './productTypeIcon.scss'

interface ProductTypeIconProps {
    iconName: LucideIconName
    label: string
}

export function ProductTypeIcon({ iconName, label }: ProductTypeIconProps) {
    return (
        <TooltipWrapper text={label} className="product-type-icon" revealOnFocus>
            <span className="product-type-icon-glyph" role="img" aria-label={label} tabIndex={0}>
                <LucideIcon iconName={iconName} size={16} strokeWidth={1.5} />
            </span>
        </TooltipWrapper>
    )
}
